import PageComponent from 'components/Dashboard/PageComponent'
import { Link } from 'gatsby'
import { DashboardTitle } from './DashboardTitleContext'
import { MatchedResults } from './Results'

const limit = 100

const PhotoVerificationQueue: PageComponent = () => {
  return (
    <div className="container">
      <DashboardTitle title="Photo Verification Queue" />

      <MatchedResults
        queueName="PhotoVerificationQueue"
        limit={limit}
        titleFn={(qty, qtyShown) => (
          <>
            <strong>{qty}</strong> photo results to verify (displaying first {qtyShown})
            <br />
            <Link className="is-size-6 has-text-weight-normal" to="/dashboard/escalated-photo-verifications">
              Escalated Photo Verification Queue
            </Link>
          </>
        )}
      />
    </div>
  )
}

PhotoVerificationQueue.displayName = 'Photo Verifications'
PhotoVerificationQueue.path = '/photo-verifications'
PhotoVerificationQueue.allowedGroups = ['dashboard', 'rapid_photo_verifiers']

export default PhotoVerificationQueue
